export default __webpack_public_path__ + "static/media/Ies_LogoMexico.63355d57.png";